import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useMediaQuery,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Cards } from "../components/MainMenu/cards";
import { useCookies } from "react-cookie";

export const popupCookie = 'popup-timestamp';

const RedirectModal = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [mediaQuery] = useMediaQuery("(max-width: 28em)");
  const [isMobile, setIsMobile] = useState(undefined);
  const [cookies, setCookie] = useCookies([]);

  useEffect(() => {
    if(mediaQuery !== isMobile) {
      setIsMobile(mediaQuery);
    }
  }, [mediaQuery]);

  const handleClick = () => {
    onClose()
    setCookie(popupCookie, new Date().getTime());
  }

  useEffect(() => {
    if(cookies[popupCookie]) {
      const difference = new Date().getTime()  - cookies[popupCookie]
      if(difference/60000 > 5) {
        onOpen()
      }
    } else {
      onOpen()
      setCookie(popupCookie, new Date().getTime());
    }
  },[])

  return (
    <Modal isOpen={isOpen} onClose={handleClick}>
      <ModalOverlay />
      <ModalContent m="0 20px" alignSelf="center">
        <ModalHeader borderTop="10px solid #EAF4FF" borderTopRadius="3px" justifyContent="space-between">
          <div>
            Idź na skróty
          </div>
          <ModalCloseButton mt="10px" />
        </ModalHeader>
        <ModalBody mb="15px">
          <Cards onClick={handleClick} background={null} isHome={true} isPopup={true} isMobile={isMobile} />
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default RedirectModal;
